module.exports = __webpack_public_path__ + "img/j.da727cef.jpg";